import React from 'react';

const MapPinIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const PhoneIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const ClockIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const FacebookIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
  </svg>
);

const ContactUs = () => {
  return (
    <section className="bg-white text-gray-900 w-full overflow-hidden" id="contact">
      <div className="mx-auto max-w-7xl px-6 pt-10 lg:pt-12 lg:px-8 pb-10 lg:pb-12">
        <div className="mb-4 text-center">
          <p className="text-base font-semibold tracking-wide text-gold">
            Contact Us
          </p>
          <h2 className="font-serif mb-4 font-semibold tracking-tight text-navy-dark text-3xl sm:text-5xl">
            Get in Touch
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-xl text-gray-700">
            Reach out to us for inquiries, support, or just to say hello.
          </p>
        </div>

        <div className="flex items-stretch justify-center">
          <div className="grid md:grid-cols-2 gap-16 w-full">
            {/* Left Column */}
            <div className="border border-gray-200 p-8">
              <p className="mb-8 text-lg text-gray-600">
                We’re here to help. Use the contact details below or visit us at our office.
              </p>
              <ul className="space-y-6">
                <li className="flex items-start">
                  <MapPinIcon className="h-6 w-6 shrink-0 text-navy" />
                  <div className="ml-4">
                    <h3 className="text-lg font-medium">Our Address</h3>
                    <p className="text-gray-600">Corner St. Thomas & 6th St</p>
                    <p className="text-gray-600">Belize City, Belize</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <PhoneIcon className="h-6 w-6 shrink-0 text-navy" />
                  <div className="ml-4">
                    <h3 className="text-lg font-medium">Contact</h3>
                    <p className="text-gray-600">
                      Tel:{' '}
                      <a href="tel:+5012230856" className="text-navy hover:underline">
                        +501 223-0856
                      </a>
                    </p>
                    <p className="text-gray-600">
                      WhatsApp:{' '}
                      <a
                        href="https://wa.me/5016237942"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-navy hover:underline"
                      >
                        +501 623-7942
                      </a>
                    </p>
                    <p className="text-gray-600">
                      Email:{' '}
                      <a
                        href="mailto:info@mcleaninsurancebrokers.com"
                        className="text-navy hover:underline"
                      >
                        info@mcleaninsurancebrokers.com
                      </a>
                    </p>
                  </div>
                </li>
                <li className="flex items-start">
                  <ClockIcon className="h-6 w-6 shrink-0 text-navy" />
                  <div className="ml-4">
                    <h3 className="text-lg font-medium">Working Hours</h3>
                    <p className="text-gray-600">Monday - Friday: 08:00 - 17:00</p>
                    <p className="text-gray-600">Saturday & Sunday: Closed</p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Right Column (Map) */}
            <div className="border border-gray-200 overflow-hidden min-h-[320px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.9801804364743!2d-88.1965228559625!3d17.508459522194453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5c59713c6b4b47%3A0xd80c63db19ff0870!2sMcLean%20Insurance%20Brokers%20%26%20Risk%20Solutions%20Ltd!5e0!3m2!1sen!2scr!4v1732074127902!5m2!1sen!2scr"
                className="w-full h-full block"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="McLean Insurance Brokers & Risk Solutions Location"
              />
            </div>
          </div>
        </div>

        {/* Social Media Section Centered */}
        <div className="flex flex-col items-center justify-center mt-8">
          <a
            href="https://www.facebook.com/McLeanInsuranceBrokers"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-gray-900 hover:text-navy"
          >
            <FacebookIcon className="h-6 w-6 shrink-0 text-navy" />
            <span className="text-lg font-medium">Follow us on Facebook</span>
          </a>
          <p className="mt-4 text-gray-600 max-w-lg text-center">
            Stay updated with the latest news and updates from McLean Insurance Brokers & Risk
            Solutions. Connect with us on Facebook!
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
